import { Route, Routes, Navigate, BrowserRouter } from 'react-router-dom';
import ModernApp from './ModernApp';

// Import global CSS for shadcn/ui
import './styles/globals.css';

// Main App Router
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root path - Redirect to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* All routes handled by ModernApp */}
        <Route path="/*" element={<ModernApp />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
